<template>
  <v-row ref="editForm" class="edit-form edit-firma-form" no-gutters>

    <v-col cols="12"
           sm="6">
      <v-text-field v-model.trim="userForm.firma"
                    name="firma"
                    label="Name" />
    </v-col>

    <v-col cols="12"
           sm="6"/>

    <v-col v-if="userForm.firma"
           cols="12"
           sm="6">
      <v-combobox v-validate="'required'"
                :value="userForm.rechtsform"
                :items="legalformsList"
                :error-messages="errors.collect('rechtsform')"
                data-vv-as="Rechtsform"
                class="required"
                name="rechtsform"
                label="Rechtsform"
                @input="setRechtsform"/>
    </v-col>

    <v-col v-if="userForm.firma"
           cols="12"
           sm="6">
      <v-text-field v-model.number="userForm.gruendungsjahr"
                    name="gruendungsjahr"
                    label="Gründungsjahr"
                    mask="####"/>
    </v-col>

    <v-col cols="12"
           sm="6">
      <v-text-field v-model="userForm.dihk"
                    v-validate="{ required: true, regex: /^D-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{5}-[a-zA-Z0-9]{2}$/ }"
                    :error-messages="errors.collect('dihk')"
                    data-vv-as="Registriernummer DIHK"
                    name="dihk"
                    label="Registriernummer DIHK"
                    hint="Format: D-xxxx-xxxxx-xx"
                    class="required" />
    </v-col>

    <v-col cols="12"
           sm="6">
      <v-combobox v-validate="'required'"
                :value="userForm.maklerverbund"
                :items="verbundeList"
                :error-messages="errors.collect('maklerverbund')"
                data-vv-as="Maklerverbund"
                class="required"
                name="maklerverbund"
                label="Mitglied in einem Maklerverbund"
                @input="setMaklerverbund"/>
    </v-col>

    <template v-if="registerMode">

      <v-col class="custom-label-radiogroup" cols="12">
        <v-row no-gutters>

          <v-col cols="12"
                 sm="3">

            <div class="my-radio-label">
              Vermittlertyp
            </div>

          </v-col>

          <v-col cols="12"
                 sm="9">

            <v-radio-group id="rb-dihk"
                           v-model="userForm.dihkrechte"
                           column>
              <v-radio label="Makler nach § 34d Abs. 1 Nr. 2 GewO"
                       value="001"
                       color="primary" />
              <v-radio label="Mehrfachagent nach §34d Abs. 1 Nr. 1 GewO"
                       value="006"
                       color="primary"/>
            </v-radio-group>

          </v-col>
        </v-row>
      </v-col>

    </template>

  </v-row>
</template>
<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import { MAKLERVERBUND_VALUES, RECHTSFORM_VALUES } from "@/components/userProfile/valueLists";
export default {
  name: "EditFirma",
  mixins: [ ValidationMixin ],
  props: {
    userForm: {
      type: Object,
      required: true
    },
    registerMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      verbundeList: [].concat(MAKLERVERBUND_VALUES),
      legalformsList: [].concat(RECHTSFORM_VALUES)
    };
  },
  methods: {
    setRechtsform (selectedItem) {
      this.userForm.rechtsform = selectedItem.value ? selectedItem.value : selectedItem;
    },
    setMaklerverbund (selectedItem) {
      this.userForm.maklerverbund = selectedItem.value ? selectedItem.value : selectedItem;
    },
    avadLink () {
      let routeData = this.$router.resolve({ name: 'RegisterPage'});
      window.open(routeData.href, '_blank');
    }
  }
};
</script>
<style>
.edit-firma-form .custom-label-inputgroup {
  display: flex;
  align-items: flex-start;
  padding-right: 48px;
}
.edit-firma-form .custom-label-inputgroup .mylabel {
  margin-left: 8px;
  margin-bottom: 16px;
  width: 100%;
}
.edit-firma-form .custom-label-radiogroup {
  display: flex;
  align-items: flex-start;
}
.edit-firma-form .custom-label-radiogroup .my-radio-label {
  padding-top: 2px;
  padding-bottom: 16px;
}
.edit-firma-form #rb-dihk {
  padding-top: 0;
}
.edit-firma-form #rb-dihk .v-radio + .v-radio {
  margin-top: 16px;
}
.edit-firma-form #rb-dihk .v-radio label {
  overflow: visible;
}
.edit-firma-form .error--text {
  font-size: 12px
}
.edit-firma-form #avad-link {
  color: #0085CF;
  cursor: pointer;
}
</style>
